import {
  tasksListTablBodyTranslation,
  TasksListTableBodyTranslation,
} from '@/assets/locales/views/tasks/list/tasksListView.translation.pl.ts';

export type DashboardViewTranslation = {
  emails: {
    noThreadsInFolder: string;
    title: string;
  };
  processes: {
    title: string;
  };
  tasks: {
    body: TasksListTableBodyTranslation;
    offer: string;
    title: string;
  };
  topBar: {
    contacts: {
      button: {
        add: string;
      };
    };
    tasks: {
      button: {
        add: string;
      };
    };
  };
};

export const dashboardViewTranslation: DashboardViewTranslation = {
  emails: {
    noThreadsInFolder: 'Brak nieprzeczytanych wiadomości',
    title: 'Ostatnie nieprzeczytane maile',
  },
  processes: {
    title: 'Procesy wymagające uwagi',
  },
  tasks: {
    body: tasksListTablBodyTranslation,
    offer: 'Oferta {{offerBusinessId}}',
    title: 'Bieżące zadania',
  },
  topBar: {
    contacts: {
      button: {
        add: 'Dodaj kontakt',
      },
    },
    tasks: {
      button: {
        add: 'Dodaj zadanie',
      },
    },
  },
};
